const { processSilentRenew } = require('redux-oidc');

processSilentRenew();
